import React, {useEffect} from 'react';
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";

// components
import AppTranslateStatisticItem from "./AppTranslateStatisticItem";

// utils
import {getStateByPath} from "../../../redux/selectors";

// services
import {applicativeService} from "../../../jwt/_services/configuration/applicativeService";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {
    setFilter,
    setForm,
    setItem,
    setLoading,
    setTableParams,
    setViewMode
} from "../../../redux/actions/generics/IndexedActions";



const TranslateStatisticsList = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { pageSize, pageIndex, listDomainObjects, filter } = componentState?.data;


    useEffect( () => {
        if(filter)
            return

        props.setFilter(path , {
            isTranslatable : true,
        });
    }, []);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, applicativeService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);


    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>Estadísticas de Traducción
        </CardTitle>
        <CardBody>
            <div className={'main-custom-container'}>
                {
                    listDomainObjects.map((item, index) => <AppTranslateStatisticItem key={index} app={item}/>)
                }
            </div>
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(TranslateStatisticsList)